import React from "react";
import "./HeroCta.scss";
import heroBg from "../../assets/hero-bg-cta.jpg"; // replace with your background image
import avenaLogo from "../../assets/logoavena.png";   // your logo path

const HeroCTA = () => {
  return (
    <section className="avena-hero-cta">
      <div
        className="avena-hero-bg"
        style={{ backgroundImage: `url(${heroBg})` }}
      ></div>

      <div className="avena-hero-overlay"></div>

      <div className="container avena-hero-content text-white">
        <div className="row">
          <div className="col-lg-8 col-md-10">
            <div className="hero-logo-wrap d-inline-flex align-items-center mb-3">
              <img src={avenaLogo} alt="Avena Logo" className="hero-logo me-2" />
              <h6 className="hero-logo-text mb-0">AVENA</h6>
            </div>

           <h1 className="hero-title">
  Your Trusted Partner in <br />
  <span>Technology & Innovation</span>
</h1>


            <div className="hero-actions">
              <a href="/contact" className="btn hero-btn mt-3">
                CONNECT WITH US
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroCTA;
